// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1e7PO","footer":"ModalError_footer__oGJqh"};